type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
};

export function CloseIcon({ width = 20, height = 20, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            className={className}
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20C15.5229 20 20.0001 15.5228 20.0001 10C20.0001 4.47715 15.5229 0 10 0C4.47716 0 0 4.47715 0 10C0 15.5228 4.47716 20 10 20ZM8.26775 6.5C7.77961 6.01184 6.98816 6.01184 6.5 6.5C6.01184 6.98815 6.01184 7.77961 6.5 8.2678L8.23225 10L6.50001 11.7322C6.01185 12.2204 6.01185 13.0118 6.50001 13.5C6.98816 13.9882 7.77962 13.9882 8.26775 13.5L10 11.7678L11.7322 13.5C12.2203 13.9882 13.0118 13.9882 13.5 13.5C13.9881 13.0118 13.9881 12.2204 13.5 11.7322L11.7677 10L13.5 8.2678C13.9881 7.77961 13.9881 6.98815 13.5 6.5C13.0118 6.01184 12.2203 6.01184 11.7322 6.5L10 8.2322L8.26775 6.5Z"
                fill="white"
                fillOpacity="0.65"
            />
        </svg>
    );
}

export default CloseIcon;
